module.exports = __webpack_public_path__ + "static/media/6.d27b90b4.jpg";